
import { useState } from "react";
import { useDashboardData } from "@/hooks/useDashboardData";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BarChart3, PieChart, TrendingUp, Users, Globe } from "lucide-react";

import { OffersStatsCards } from "./OffersStatsCards";
import { EmployeeOffersChart } from "./EmployeeOffersChart";
import { CountryOffersChart } from "./CountryOffersChart";
import ClientStatusAnalysis from "./ClientStatusAnalysis";
import SalesPerformanceChart from "./SalesPerformanceChart";
import TopCountriesWidget from "./TopCountriesWidget";
import TopEmployeesRanking from "./TopEmployeesRanking";
import SmartNotifications from "./SmartNotifications";

const OptimizedAnalytics = () => {
  const { data: dashboardData, isLoading, error } = useDashboardData();

  if (error) {
    return (
      <Card className="border-red-200 bg-red-50">
        <CardContent className="p-6 text-center">
          <p className="text-red-700 font-medium">حدث خطأ في تحميل البيانات</p>
          <p className="text-red-600 text-sm mt-2">يرجى المحاولة مرة أخرى</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      {/* إحصائيات العروض */}
      <OffersStatsCards 
        data={dashboardData?.offers || { today: { count: 0, revenue: 0 }, yesterday: { count: 0, revenue: 0 }, month: { count: 0, revenue: 0 } }}
        isLoading={isLoading}
      />

      {/* التبويبات الرئيسية */}
      <Tabs defaultValue="employees" className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 lg:grid-cols-3 h-auto p-1">
          <TabsTrigger value="employees" className="flex items-center gap-2 py-3">
            <Users className="w-4 h-4" />
            <span className="hidden sm:inline">تحليل الموظفين</span>
          </TabsTrigger>
          <TabsTrigger value="countries" className="flex items-center gap-2 py-3">
            <Globe className="w-4 h-4" />
            <span className="hidden sm:inline">تحليل الدول</span>
          </TabsTrigger>
          <TabsTrigger value="performance" className="flex items-center gap-2 py-3">
            <TrendingUp className="w-4 h-4" />
            <span className="hidden sm:inline">الأداء</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="employees" className="space-y-6">
          <EmployeeOffersChart 
            data={dashboardData?.employeeOffers || []}
            isLoading={isLoading}
          />
          <TopEmployeesRanking />
        </TabsContent>

        <TabsContent value="countries" className="space-y-6">
          <CountryOffersChart 
            data={dashboardData?.countryOffers || []}
            isLoading={isLoading}
          />
          <TopCountriesWidget />
        </TabsContent>

        <TabsContent value="performance" className="space-y-6">
          <SalesPerformanceChart />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ClientStatusAnalysis />
            <SmartNotifications />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default OptimizedAnalytics;
